import styled from "styled-components";

export const StyledBottomAppBar = styled.div<{ $bottomAppBarBottom: number }>`
  width: 100%;
  height: 80px;
  position: fixed;
  bottom: ${({ $bottomAppBarBottom }) => `${$bottomAppBarBottom}px`};
  transition: bottom 0.2s;

  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  z-index: 4;
  /* ActionPanel 内の CommentField（CommentFieldContainer）と同一のグラス。
     コンテンツはバーの背後を通ってビューポート下端まで描画されるため、
     入力欄と同じ質感で背後のメッセージやアンビエント色が透けて見える */
  background: rgba(255, 255, 255, 0.16);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(13px);
  -webkit-backdrop-filter: blur(13px);
`;

export const StyleIconBtn = styled.div.attrs({
  className: "u-col-center u-gap2 u-relative"
})<{ $isActive?: boolean }>`
  width: 64px;
  color: var(--soremo-light-gray);

  transition: 0.2s;

  .material-symbols-rounded {
    color: var(--soremo-light-gray);
  }

  &:hover {
    cursor: pointer;
    color: var(--soremo-blue);
    transform: scale(1.1);

    .material-symbols-rounded {
      color: var(--soremo-blue);
    }
  }

  ${({ $isActive }) => $isActive && `
    color: var(--soremo-blue);

    .material-symbols-rounded {
      color: var(--soremo-blue);
    }
  `}
`;